// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__FTv7a","inputWrap":"Table_inputWrap__1Bei-","col":"Table_col__2-o70","bmiTooltip":"Table_bmiTooltip__x0bFt"};